import { useCurrentUserQuery, UserHelpRequestInput, useUserHelpRequest } from '@alice-financial/alice-sdk'
import { Button, Grid, TextField, Typography } from '@alice-financial/pretext-ui'
import * as React from 'react'
import { useForm } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router'

export const NotifyChange = () => {
  const { data: currentUserData } = useCurrentUserQuery()
  const location = useLocation()
  const { mutate: requestHelp, isSuccess, isLoading } = useUserHelpRequest()
  const { handleSubmit, register, watch } = useForm<UserHelpRequestInput>({
    defaultValues: {
      message: '',
      fromUrl: location.pathname,
    },
  })
  if (!currentUserData?.currentUser) return null
  const disabled = isSuccess || isLoading
  if (isSuccess) {
    return (
      <Typography variant="caption" component="p">
        <FormattedMessage id="contact_support.help_request.success" />
      </Typography>
    )
  }
  return (
    <Grid container rowGap={2}>
      <Grid size={12}>
        <Typography variant="caption">
          <FormattedMessage id="contact_support.help_request.changing_payroll" />
        </Typography>
      </Grid>
      <Grid
        container
        size={12}
        component="form"
        onSubmit={handleSubmit(({ message, fromUrl }) => {
          const _message = `UPCOMING PAYROLL CHANGE: ${message}`
          requestHelp({ message: _message, fromUrl })
        })}
        rowGap={2}
        maxWidth="sm"
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        <Grid size={12}>
          <TextField multiline {...register('message')} fullWidth disabled={disabled} />
        </Grid>
        <Grid container flexDirection="row-reverse">
          <Button variant="contained" type="submit" disabled={!watch('message')}>
            <FormattedMessage id="common.submit" />
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}
